"use strict";

const RoutineInspectionRouteFactory = require("./routineInspectionRouteFactory");

const OpenChannelRoutes = function () {
  const inspectionRoute = RoutineInspectionRouteFactory.createRoute({
    resourceKey: "openChannelRoutineMaintenance",
    assetType: "openChannel",
  });

  return { inspectionRoute };
};

module.exports = OpenChannelRoutes();
